import { Controller } from "stimulus";
import DiscountPackage from "./enrollment/discount_package";
import EnrollmentContract from "./enrollment/enrollment_contract";
import WizardStepsForm from "../entrypoints/src/admin/components/wizard_steps/wizard_steps_form";
import Student from "./enrollment/student";
import PaymentMethod from "./enrollment/payment_method";
import sweet_alert from "../entrypoints/src/admin/utilities/sweet_alert";

import 'select2';
import 'select2/dist/css/select2';

export default class extends Controller {
  connect() {
    this.$btnsSave = document.querySelectorAll('button.save-enroll');
    this.$form = document.querySelector('form.enrollment-form');
    this.stepWizardSelector = '#enrollment-steps-desktop';
    this.wizard = this.initializeWizard();
    this.bindingSteps();

    $('.select2').select2({
      escapeMarkup: (markup) => markup,
    });
  }

  initializeWizard() {
		return WizardStepsForm
			.prepare(document.querySelector(this.stepWizardSelector))
      .addEventListener('change', this.updateStatus.bind(this))
      .step('discount-package', (step) => {
        new DiscountPackage(this.element, step)
          .beforeSelect(this.beforeSelectDiscountPackage.bind(this))
          .onSkipButton(this.onSkipDiscountsButton.bind(this))
          .onUpdate(this.onDiscountPackageUpdate.bind(this))
          .onContinue(this.onContinueAtDiscountPackage.bind(this));
      })
      // .step('contracts', (step) => new EnrollmentContract(this.element, step))
      .step('student-info', (step) => new Student(this.element, step))
      .step('payment-method', (step) => new PaymentMethod(this.element, step))
			.start();
	}

  updateStatus() {
		if (!this.wizard)
			return;

		let canSave = ['discount-package', 'student-info'/*, 'contracts'*/, 'payment-method'].reduce((a, stepId) => a &= this.wizard.getStep(stepId).valid, true);

		this.element.classList.toggle('invalid-enrollment', !canSave);
		this.element.classList.toggle('active-enrollment', canSave);
		[...this.$btnsSave].map(($btn) => $btn.classList.toggle('disabled', !canSave));
	}

  beforeSelectDiscountPackage(_$card) {
    return this.destroyContracts('Para selecionar esse pacote, todos os contratos já preenchidos serão excluídos da matrícula. Gostaria de continuar?');
	}

  onSkipDiscountsButton() {
		return this.destroyContracts('Para continuar sem pacote, todos os contratos selecionados serão excluídos. Gostaria de continuar?');
	}

  onDiscountPackageUpdate(discountPackage) {
    let $a = this.element.querySelector('a[data-turbo-frame="enrollmentcontract"]');
    if (!$a) return;
    $a.setAttribute('href', !!discountPackage.id ? this.appendDiscountPackageId($a.getAttribute('href'), discountPackage) : this.removeDiscountPackageId($a.getAttribute('href')));
	}

  onContinueAtDiscountPackage() {
		this.wizard.selectStep('student-info');
	}

  destroyContracts(alertMessage) {
    let _self = this;

    return new Promise((resolve, reject) => {
			if (_self.element.querySelectorAll('.at-contracts > turbo-frame a.destroy-contract').length == 0)
				return resolve();

      sweet_alert.fire({
        title: 'Atenção!',
        text: alertMessage,
        icon: 'warning',
        showCancelButton: false,
        showCancelButton: true,
        confirmButtonText: 'Sim, pode excluir!',
        cancelButtonText: 'Não, cancelar!'
      }).then((resp) => {
        if (!resp.isConfirmed)
          reject();

        _self.element.querySelectorAll('.at-contracts > turbo-frame').forEach((turboFrame) => {
          let form = turboFrame.querySelector('form'),
            anchor = form.querySelector('a.destroy-contract');

          if (!form || !anchor)
            return;

          let htmlForm = `
            <form action="${anchor.getAttribute('href')}" method="delete">
              <input type="hidden" name="_method" value="delete" />
              <button class="hidden button-destroy-contract"></button>
            </form>
          `;
          turboFrame.insertAdjacentHTML('afterbegin', htmlForm);
          turboFrame.querySelector('form button.button-destroy-contract').click();
        });
        resolve();
      });
		});
  }

  appendDiscountPackageId(url, discountPackage) {
    return `${url}&dp=${discountPackage.id}`
  }

  removeDiscountPackageId(url) {
    return url.replace(/\&dp=(.+)$/, '');
  }

  bindingSteps() {
		$(document).on('click', '.step-back', () => this.wizard.stepBack());
		$(document).on('click', '.step-forward', () => this.wizard.stepForward());
		this.$btnsSave.forEach(($btn) => {
			$btn.addEventListener('click', (ev) => {
				ev.preventDefault();

				if ($btn.classList.contains('disabled')) {
					return sweet_alert.fire({
						title: 'Matrícula Incompleta',
						text: 'Complete os dados para pode salvar a matrícula!'
					});
				}

				this.$form.submit();
			});
		});
	}
}